<template>
  <div class="about">
    <div class="banner">
      <div class="banner_title">
        <h1>联系我们</h1>
        <p>CONTACT US</p>
      </div>
    </div>
    <div class="service_bd">
      <LeftNav
        title="联系我们"
        :list="list"
        @event1="change($event)"
        bigTitle="CONTACT US"
        :key="changing"
        :newData="newData"
      ></LeftNav>
      <div class="bd_right">
        <router-view></router-view>

        <!-- <aboutItem1
          title="联系我们"
          :list="list"
          :newData="newData"
          v-if="newData == 0"
        ></aboutItem1>
         <aboutItem2
          title="联系我们"
          :list="list"
          :newData="newData"
          v-if="newData == 1"
        ></aboutItem2> -->
      </div>
    </div>
  </div>
</template>
  <script>
import LeftNav from "../components/leftNav.vue";

export default {
  name: "About",
  data() {
    return {
      changing: 0,
      list: [
        {
          title: "联系我们",
          small_title: "CONTACT US",
          hasTitle: "联系我们",
          show: false,
        },
        {
          title: "加入我们",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "加入我们",
        },
      ],
      newData: 0,
    };
  },
  methods: {
    change(data) {
      this.newData = data;
      this.changing += 1;
 
    },
  },
  mounted: function () {
    // this.$router.push({ path: "/About/contact" });
  },
  components: {
    LeftNav,
  },
  watch: {
    newData: {
      handler: function () {
        //do something
        if (this.newData == 0) {
          this.$router.push({ path: "/About/contact" });
        } else {
          this.$router.push({ path: "/About/recruit" });
        }
      },
      deep: true,
    },
    $route: {
      handler(newRouter) {
        if (newRouter.path == "/About/contact") {
          this.newData = 0;
        } else if (newRouter.path == "/About/recruit") {
          this.newData = 1;
        }
      },
       immediate: true,
    },
  },
};
</script>
<style scoped="scoped">
.banner {
  width: 100%;
  height: 8.75rem;
  background-image: url("../assets/image/about_banner.png");
  background-size: 100% 100%;
  position: relative;
}
.banner_title {
  position: absolute;
  left: 2.5rem;
  bottom: 2.125rem;
  width: 5.6625rem;
  height: 2.6375rem;
  background-color: rgba(64, 104, 76, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 0.4875rem;
}
.banner_title h1 {
  font-size: 0.65rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.banner_title p {
  font-size: 0.4rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #ffffff;
}
.service_bd {
  padding: 0.75rem 2.5rem 0;
  display: flex;
  justify-content: space-between;
}
.bd_right {
  width: 12.6rem;
  padding-bottom: 4.4125rem;
}
</style>